export default __webpack_public_path__ + "static/media/Dive5.8284c1b8.png";